module.exports = __webpack_public_path__ + "static/media/office5.ffba1110.jpg";